import { EventInput } from '@deqo/podopolis';
import { easeInOutCubic } from 'just-curves';
import { waitFor } from '../../../CodesThatsGottaGoSomewhereElse';
import { UserLiteData } from '../../../api/ApiTypes';
import { Point, PointSource } from '../../../platform/geom/Point';

export class KioskActor {

    private clientId: string;
    private position: Point;

    constructor(public readonly user: UserLiteData, profile: any, private inbound: EventInput<any>) {
        this.clientId = profile.clientId;
        this.position = new Point(profile.px, profile.py);
    }

    public async replay(recording: any[]) {

        // If we have an existing position, then we to tween into position

        // const x = Path.from(null);
        // this.flow(2, t => {
        //     const xy = x.pointAt(t);
        // });

        const start = performance.now();

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < recording.length; i++) {
            const [time, type, data] = recording[i];

            const ellapsed = performance.now() - start;
            if (time > ellapsed) {
                await waitFor(time - ellapsed);
            }

            if (type === 'update_profile') {
                this.inbound.emit('notify_profile', [[this.clientId, ...data]]);
            }
            else if (type === 'submit_tx') {
                this.inbound.emit('notify_tx', [[
                    this.user.id,
                    1000,
                    1000,
                    ...data.slice(2)
                ]]);
            }

            // source      0: "FU1100000539"
            // time        1: 276
            // version     2: 23
            // mode        3: 2
            // reads       4: []
            // writes      5: (9) [Array(4), Array(4), Array(4), Array(4), Array(4), Array(4), Array(4), Array(4), Array(4)]

        }
    }

    public async moveTo(xy: PointSource, seconds?: number) {

        const from = this.position;
        const to = Point.from(xy);
        const mov = Point.vector(from, to);

        seconds = seconds || mov.magnitude() / 400;

        await this.flow(seconds, t => {
            t = easeInOutCubic(t);
            const p = this.position = from.add(mov.multiply(t));
            const puts = Object.entries({ px: p.x, py: p.y });
            this.inbound.emit('notify_profile', [[this.clientId, puts, []]]);
        });
    }

    public async wearHat() {
        this.inbound.emit('notify_topic', [['hatting', { [this.user.id]: ['wear', 'Top'] }]]);
        await waitFor(100);
    }

    private flow = async (seconds: number, callback: (t: number) => void) => {

        const fps = 15;
        const fs = seconds * fps;
        const wt = (seconds / fs) * 1000;

        for (let i = 0; i < fs; i++) {
            callback(i / fs);
            await waitFor(wt);
        }
    };
}
